import { render, staticRenderFns } from "./InsertCoupons.vue?vue&type=template&id=271458f4&scoped=true"
import script from "./InsertCoupons.vue?vue&type=script&lang=js"
export * from "./InsertCoupons.vue?vue&type=script&lang=js"
import style0 from "./InsertCoupons.vue?vue&type=style&index=0&id=271458f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271458f4",
  null
  
)

export default component.exports